import React from "react";
import MaleFemale from "@assets/images/dashboard/male-female.png";

type ChartData = {
  name: string;
  value: number;
};

interface PackedBubbleChartProps {
  title: string;
  data: ChartData[];
}

const PackedBubbleChart: React.FC<PackedBubbleChartProps> = ({
  title,
  data,
}) => {
  const male =
    data.find((item) => item.name.toLowerCase() === "male")?.value || 0;

  const female =
    data.find((item) => item.name.toLowerCase() === "female")?.value || 0;

  const maxValue = Math.max(male, female, 1);

  const getBubbleSize = (
    value: number,
    minSize: number,
    maxSize: number
  ) => {
    return Math.max(
      minSize,
      minSize + (value / maxValue) * (maxSize - minSize)
    );
  };

  // Dynamically scale bubbles
  const femaleSize = getBubbleSize(female, 100, 220);
  const maleBubbleSize = getBubbleSize(male, 70, 160);

  // Decorative image bubble
  const imageBubbleSize = 130;

  const containerWidth = Math.max(
    femaleSize + imageBubbleSize + 80,
    320
  );

  const containerHeight = Math.max(
    femaleSize + 50,
    260
  );

  return (
    <div className="pt-8 px-4 pb-4 rounded-xl border">
      <h2 className="text-sm font-semibold text-gray-600 mb-4">
        {title}
      </h2>

      <div className="bg-white w-full">
        <div className="flex items-center justify-between flex-wrap">
          {/* Legend */}
          <div>
            <div className="flex items-center mb-3">
              <div
                className="rounded-sm mr-2"
                style={{
                  width: "10px",
                  height: "10px",
                  background: "#7BC35F",
                }}
              />
              <span className="text-sm font-medium text-gray-700">
                MALE
              </span>
            </div>

            <div className="flex items-center">
              <div
                className="rounded-sm mr-2"
                style={{
                  width: "10px",
                  height: "10px",
                  background: "#F4D44D",
                }}
              />
              <span className="text-sm font-medium text-gray-700">
                FEMALE
              </span>
            </div>
          </div>

          {/* Bubble Chart */}
          <div
            className="relative mx-auto"
            style={{
              width: containerWidth + "px",
              height: containerHeight + "px",
            }}
          >
            {/* Female Bubble */}
            <div
              className="absolute rounded-full flex items-center justify-center font-bold text-black"
              style={{
                width: femaleSize + "px",
                height: femaleSize + "px",
                left: "0px",
                top: "40px",
                background: "#F4D44D",
                fontSize: Math.max(femaleSize * 0.22, 24) + "px",
              }}
            >
              {female}
            </div>

            {/* Image Bubble */}
            <div
              className="absolute rounded-full flex items-center justify-center"
              style={{
                width: imageBubbleSize + "px",
                height: imageBubbleSize + "px",
                left: femaleSize * 0.72 + "px",
                top: "0px",
                background: "#070733",
                border: "4px solid white",
              }}
            >
              <img
                src={MaleFemale}
                alt="gender-art"
                style={{
                  width: imageBubbleSize * 0.55 + "px",
                  height: imageBubbleSize * 0.55 + "px",
                  objectFit: "contain",
                }}
              />
            </div>

            {/* Male Bubble */}
            <div
              className="absolute rounded-full flex items-center justify-center font-bold text-black"
              style={{
                width: maleBubbleSize + "px",
                height: maleBubbleSize + "px",
                left: femaleSize * 0.75 + "px",
                top: imageBubbleSize * 0.9 + "px",
                background: "#7BC35F",
                border: "4px solid white",
                fontSize: Math.max(maleBubbleSize * 0.28, 18) + "px",
              }}
            >
              {male}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackedBubbleChart;